export const GUIDES = [
  {
    slug: "first-time-investor",
    title: "First-Time Investor Checklist",
    line: "Twelve steps — from emergency fund to your first SIP — in the right order.",
    icon: "Sprout",
    cover: "/img/cover-sip.webp",
    articles: ["sip-explained", "emergency-fund", "asset-allocation"],
    services: ["mutual-funds", "investments"],
  },
  {
    slug: "family-protection",
    title: "Family Protection Checklist",
    line: "Life cover, health cover and the paperwork your family can actually find.",
    icon: "ShieldCheck",
    cover: "/img/cover-insurance.webp",
    articles: ["term-vs-life-insurance"],
    services: ["insurance"],
  },
  {
    slug: "tax-planning-calendar",
    title: "Year-Round Tax Planning Calendar",
    line: "A quarter-by-quarter plan so March is never a scramble again.",
    icon: "CalendarDays",
    cover: "/img/cover-tax.webp",
    articles: ["tax-planning-framework"],
    services: ["tax-planning"],
  },
  {
    slug: "home-loan-readiness",
    title: "Home-Loan Readiness Checklist",
    line: "Prepare, compare lenders and size the EMI so it fits your plan.",
    icon: "Home",
    cover: "/img/cover-loans.webp",
    articles: ["borrowing-smart", "retirement-corpus", "fixed-income-101"],
    services: ["loans", "fixed-income", "financial-planning", "advanced"],
  },
];

export const guideForArticle = (slug) => GUIDES.find((g) => g.articles.includes(slug)) || GUIDES[0];
export const guideForService = (id) => GUIDES.find((g) => g.services.includes(id)) || GUIDES[0];
